import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateLabelTemplateContent,
    LabelTemplateContent,
    LabelTemplateContentListResponse,
    LabelTemplateContentQueryParams,
    UpdateLabelTemplateContent
} from '@frontend/label/types';

export class LabelTemplateContentClient extends APIClient {
    public static readonly endpoint = '/label-api/v1';

    public static async fetchLabelTemplateContents(queryParams?: ApiQueryParams<LabelTemplateContentQueryParams>): Promise<LabelTemplateContentListResponse> {
        return await this.apiPaginated<LabelTemplateContentListResponse, LabelTemplateContentQueryParams>(`${this.endpoint}/contents`, queryParams);
    }

    public static async resolveLabelTemplateContents(ids: string[], field: keyof LabelTemplateContent = 'id'): Promise<LabelTemplateContentListResponse> {
        const response = await this.post(`${this.endpoint}/contents-resolve`, { field, ids: ids });
        return await this.handleResponse<LabelTemplateContentListResponse>(response);
    }

    public static async deleteLabelTemplateContents(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/contents-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postLabelTemplateContent(accountId: string, templateId: string, body: CreateLabelTemplateContent): Promise<LabelTemplateContent> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents`, body);
        return await this.handleResponse<LabelTemplateContent>(response);
    }

    public static async fetchAccountLabelTemplateContent(accountId: string, templateId: string, contentId: string): Promise<LabelTemplateContent> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}`);
        return await this.handleResponse<LabelTemplateContent>(response);
    }

    public static async patchLabelTemplateContent(
        accountId: string,
        templateId: string,
        contentId: string,
        body: UpdateLabelTemplateContent
    ): Promise<LabelTemplateContent> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}`, body);
        return await this.handleResponse<LabelTemplateContent>(response);
    }

    public static async deleteLabelTemplateContent(accountId: string, templateId: string, contentId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}`);
        return await this.handleVoidResponse(response);
    }

    public static async previewLabelTemplateContent(accountId: string, templateId: string, contentId: string): Promise<LabelTemplateContent> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}/preview`);
        return await this.handleResponse<LabelTemplateContent>(response);
    }
}
